import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';

export const useListingName = (): string => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);
  const address = listing?.address;
  const street = address?.hideStreet ? '' : address?.street;

  return (
    (listing as unknown as { propertyName?: string })?.propertyName ||
    (listing as unknown as { displayName?: string })?.displayName ||
    street ||
    ''
  );
};
